import { angular, app } from '../../app.module'
app
  // 日付の期間を指定するPicker
  .directive('dateRangePicker', ($state) => {
    // カレンダーが開いているかのフラグ
    let openFlg = false

    // 言語
    const language = 'ja'

    return {
      restrict: 'EA',
      template: require('./date-range-picker.pug')(),
      controller: function ($scope, $element, $attrs, $rootScope) {
        // 過去31日と過去7日の場合の、開始日と終了日のMomentオブジェクトを返す
        function getTermMoment(startDays: number, startTimeFormat: string) {
          // 開始日のmomentオブジェクトを生成
          const startMoment = moment(moment().subtract(startDays, 'days').format(startTimeFormat))

          // 終了日の日数
          let endDays = 1

          if ($attrs.type === 'trendword') {
            endDays = 0
          }

          // 終了日のmomentオブジェクトを生成
          const endMoment = moment(moment().subtract(endDays, 'days').format('YYYY-MM-DD 23:59:59'))

          return {
            startMoment: startMoment,
            endMoment: endMoment,
          }
        }

        // 開始日の日数(default: 過去7日)
        let startDays = 7
        let startTimeFormat = 'YYYY-MM-DD 00:00:00'
        let maxDays = 100

        // アカウント分析の場合、366日前を指定また、開始日をその月の初日にセット
        if ($attrs.type === 'account-detail') {
          startDays = 366
          startTimeFormat = 'YYYY-MM-01 00:00:00'
          maxDays = 400
        } else if (
          $state.current !== undefined &&
          ($state.current.name === 'account' || $state.current.name === 'analytics')
        ) {
          // 現在開いているステート名がaccountの場合
          startDays = 31
        }

        let period = getTermMoment(startDays, startTimeFormat)

        // 画面表示用に開始日時と終了日時をセット
        $scope.startEndDate =
          moment(period.startMoment).format('ll') + ' - ' + moment(period.endMoment).format('ll')

        // DatePickerの色付け用の期間を初期の日付に指定する
        let startDateStr = moment(period.startMoment).format('YYYY-MM-DD')
        let endDateStr = moment(period.endMoment).format('YYYY-MM-DD')

        // ESCボタンを押すと、date-picker-wrapperを表示しない
        $element.keyup((e) => {
          if (e.keyCode === 27) {
            openFlg = false
            angular.element('.date-picker-wrapper').remove()
          }
        })

        $scope.show = function () {
          let bindFlg = false

          // すでにカレンダーが開いている場合、ボタンを押しても反応しないようにする
          if (openFlg) {
            return
          }

          // カレンダーが開いている状態にセット
          openFlg = true

          // カレンダーの選択可能期間
          const minDate = moment().subtract(12, 'month').format('YYYY-MM-01')
          const maxDate = period.endMoment.format('YYYY-MM-DD')

          // アカウント詳細モーダル画面の場合
          if ($attrs.type === 'account-detail') {
            // 位置調整用に独自クラスを追加した後表示する
            setTimeout(() => {
              angular.element('.date-picker-wrapper').addClass('detail-modal').show()
            })
          } else {
            setTimeout(() => {
              angular.element('.date-picker-wrapper').addClass('default').show()
            })
          }

          // カレンダーの設定
          $element
            .dateRangePicker({
              alwaysOpen: false,
              language: language,
              separator: ' - ',
              shortcuts: null,
              startDate: minDate,
              endDate: maxDate,
              maxDays: maxDays,
              singleMonth: 'auto',
              customShortcuts: getCustomShortcut(),
            })
            .bind('datepicker-apply', function (event, obj) {
              // カレンダーを初期化した場合は、何もしないでリターン。
              if (bindFlg === true) {
                return
              }
              bindFlg = true
              // データ取得が押下された時に実行
              // 手動で期間を選択した場合はこちらでmomentオブジェクトを生成する
              const newStartMoment = moment(moment(obj.date1).format('YYYY-MM-DD 00:00:00'))
              const newEndMoment = moment(moment(obj.date2).format('YYYY-MM-DD 23:59:59'))

              // ボタン部分に表示する選択期間の文字列(例:yyyy年MM月dd日-yyyy年MM月dd日)を変更後の日付に変更
              $scope.startEndDate = newStartMoment.format('ll') + ' - ' + newEndMoment.format('ll')
              // startDate,endDateを画面側で用意し、その値を更新する。$watchを使用して変更があった場合処理を実行する形でコーディングする。
              // $applyは、通常angularJSでは自動で読まれるが、Jquery上のため使っている。
              $scope.$apply(function () {
                // スコープに保存するために変更した日付のUnixTimeStampを保存
                $scope.startDate = newStartMoment.unix()
                $scope.endDate = newEndMoment.unix()
              })
              // 日付の変更をイベント送信する
              $rootScope.$broadcast('changeDateRange', {
                startDate: newStartMoment.unix(),
                endDate: newEndMoment.unix(),
              })

              // DatePickerの色付け用の期間を変更した日付に設定
              startDateStr = newStartMoment.format('YYYY-MM-DD')
              endDateStr = newEndMoment.format('YYYY-MM-DD')
              // 要素を削除
              angular.element('.date-picker-wrapper').remove()
            })
            .bind('datepicker-close', function () {
              // カレンダーが閉じた時に実行される
              // カレンダーが閉じている状態にセット
              openFlg = false
              // 要素を削除
              angular.element('.date-picker-wrapper').remove()
              // カレンダー側の開始日付と終了日付をセット
            })
            .data('dateRangePicker')
            .setDateRange(startDateStr, endDateStr)
        }

        function getCustomShortcut() {
          let customShortcuts = [
            {
              name: '今月',
              dates: function () {
                // 今月の1日を開始日に指定
                const start = moment().startOf('month').toDate()
                // 画面毎に設定されている最終日を終了日に指定
                const end = period.endMoment.toDate()

                return [start, end]
              },
            },
            {
              name: '先月',
              dates: function () {
                // 先月の1日を開始日に指定
                const start = moment().subtract(1, 'month').startOf('month').toDate()
                // 先月の末日を終了日に指定
                const end = moment().subtract(1, 'month').endOf('month').toDate()

                return [start, end]
              },
            },
            {
              name: '先週',
              dates: function () {
                // 先週の初日を開始日に指定
                const start = moment().subtract(1, 'week').startOf('week').toDate()
                // 先週の最終日を終了日に指定
                const end = moment().subtract(1, 'week').endOf('week').toDate()

                return [start, end]
              },
            },
            {
              name: '過去7日',
              dates: function () {
                // 7日のフラグをtrueにセット
                period = getTermMoment(7, 'YYYY-MM-DD 00:00:00')

                // 日付の範囲を設定
                const start = period.startMoment.toDate()
                const end = period.endMoment.toDate()

                return [start, end]
              },
            },
            {
              name: '過去31日',
              dates: function () {
                // 31日のフラグをtrueにセット
                period = getTermMoment(31, 'YYYY-MM-DD 00:00:00')

                // 日付の範囲を設定
                const start = period.startMoment.toDate()
                const end = period.endMoment.toDate()

                return [start, end]
              },
            },
          ]

          // 過去3ヶ月
          const shortcut3MonthAgo = {
            name: '過去3ヶ月',
            dates: function () {
              // 日付の範囲を設定
              const end = moment().subtract(1, 'months').endOf('month').toDate()
              const start = moment().subtract(3, 'months').startOf('month').toDate()

              return [start, end]
            },
          }

          // 過去6ヶ月
          const shortcut6MonthAgo = {
            name: '過去6ヶ月',
            dates: function () {
              // 日付の範囲を設定
              const end = moment().subtract(1, 'months').endOf('month').toDate()
              const start = moment().subtract(6, 'months').startOf('month').toDate()

              return [start, end]
            },
          }

          // 過去12ヶ月
          const shortcut12MonthAgo = {
            name: '過去12ヶ月',
            dates: function () {
              // 日付の範囲を設定
              const end = moment().subtract(1, 'months').endOf('month').toDate()
              const start = moment().subtract(12, 'months').startOf('month').toDate()

              return [start, end]
            },
          }

          if (
            ($state.current.name === 'post' ||
              $state.current.name === 'analytics' ||
              $state.current.name === 'account' ||
              $state.current.name === 'archive') &&
            $attrs.type !== 'account-detail'
          ) {
            customShortcuts = customShortcuts.concat([shortcut3MonthAgo])
          } else {
            customShortcuts = customShortcuts.concat([
              shortcut3MonthAgo,
              shortcut6MonthAgo,
              shortcut12MonthAgo,
            ])
          }

          return customShortcuts
        }
      },
    }
  })
